<template>
  <div class="animated fadeIn">
    <div class="card notification notification-view">
      <div class="card-body" v-if="loading === false">
        <div class="details">
          <div class="title">{{ notification.title }}</div>
          <div class="header">
						<div class="mr-2">
							<user-photo
								:id="notification.user_id"
							></user-photo>
						</div>
            <div class="from"><router-link :to="'/users/' + notification.user_id"><span>{{ notification.user.first_name }} {{ notification.user.last_name }}</span></router-link> <a :href="'mailto:' + notification.user.email">{{ notification.user.email }}</a></div>
            <div class="date">{{ dateFormatter(notification.created_at) }}</div>
          </div>
          <div class="content" v-html="notification.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import store from '@/store'
import moment from 'moment'
import stringtohexcolor from '@bezlepkin/stringtohexcolor'
import notificationHTTP from '@/api/modules/notification/notification'
import userHTTP from '@/api/modules/user/user'
import UserPhoto from '@/components/user/user-photo'
export default {
	components: {
		UserPhoto
	},
	data () {
		return {
			loading: true,
			id: null,
			notification: null,
			defaultProfilePhotoString: '',
			defaultProfilePhotoColor: ''
		}
	},
	created () {
		this.id = parseInt(this.$route.params.id)
		// this.getNotification()
	},
	methods: {
		getNotification () {
			this.loading = true
			notificationHTTP.findOne(this.id).then((notification) => {
				this.notification = notification
				userHTTP.findOne(notification.user_id).then((user) => {
					this.notification.user = user
					this.notification.text = this.textPrepare(this.notification.text)
					this.createDefaultProfilePhoto()
					this.loading = false
					this.markAsRead()
				})
			})
		},
		markAsRead () {
			// if (this.notification.status === 2) return false
			notificationHTTP.update(this.id, {status: 2}).then((result) => {
				store.dispatch('notification/sync')
			})
		},
		createDefaultProfilePhoto () {
			const color = stringtohexcolor(this.notification.user.first_name + ' ' + this.notification.user.last_name)
			this.defaultProfilePhotoColor = '#' + color.color
			this.defaultProfilePhotoString = color.string
		},
		textPrepare (text) {
			let urlRegex = /(https?:\/\/[^\s]+)/g
			var linkTagRegex = /<a(.*?)<\/a>/g
			text = text.replace(linkTagRegex, (link) => {
				link = link.replace(urlRegex, (url) => {
					let _url = url.split('"')[0].replace('cp.legalbis.ru/api', 'cp.legalbis.ru/#')
					return '<a href="' + _url + '" target="_blank">' + _url + '</a>'
				})
				return link.replace('<a href="', '')
			})
			return text
		},
		dateFormatter (date) {
			date = moment(date).format('YYYY-MM-DD')
			moment.locale('ru')
			// если сегодня
			let currYear = moment().format('YYYY')
			if (date === moment().format('YYYY-MM-DD')) return 'Сегодня'
			// если текущий год/не текущий год
			if (currYear === moment().format('YYYY')) {
				return moment(date).format('D MMMM')
			} else {
				return moment(date).format('D MMMM, YYYY')
			}
		}
	},
	watch: {
		'$route.params': {
			handler: function (params) {
				this.id = parseInt(params.id)
				this.getNotification()
			},
			deep: true,
			immediate: true
		}
	}
}
</script>
<style lang="scss">
.notification {
  .details {
    .title {
      padding: 1rem 0;
      font-weight: 700;
    }
    .header {
      display: flex;
      padding: 1rem 0;
      margin: 1rem 0;
      border-top: 1px solid #c8ced3;
      border-bottom: 1px solid #c8ced3;
      .profile-photo {
        width: 40px;
				height: 40px;
				.profile-photo-default {
					display: flex;
					align-items: center;
					justify-content: center;
					width: 100% !important;
					height: 100%;
					color: #fff;
					text-transform: uppercase;
					font-size: 1.3em;
				}
				&:hover {
					text-decoration: none !important;
				}
			}
      .from {
        align-self: center;
        font-size: 12px;
        color: #73818f;
        span {
          display: block;
          font-weight: 700;
        }
      }
      .date {
        margin-left: auto;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/notification/view.vue